import { DesktopHeader } from './layouts/DesktopHeader';

export const Header = () => {
  return <DesktopHeader />;
};
